import React from 'react';
import styled from 'styled-components';

import Section from '../global/section';
import Top from '../top';

const StyledVideo = styled.div`
	text-align: center;
	section > div {
		max-width: 1100px;
	}
	h2 {
		margin-bottom: 2rem;
	}
	.flex {
		display: flex;
		margin-top: 3rem;
		.left {
			width: 60%;
			display: flex;
			justify-content: center;
			align-items: center;
			padding-right: 2rem;
			.video-container {
				width: 100%;
				position: relative;
				padding-bottom: calc(900% / 16);
				iframe {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}
			}
		}
		.right {
			width: 40%;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			.bandcamp-container {
				width: 80%;
				max-width: 290px;
				position: relative;
				padding-bottom: calc(940% / 7);
				iframe {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}
			}
			p {
				margin: -5rem 0 2rem;
				@media all and (max-width: 1080px) {
					margin: -3rem 0 2rem;
				}
				@media all and (max-width: 1030px) {
					margin: -1rem 0 2rem;
				}
				@media all and (max-width: 950px) {
					margin: 1rem 0 2rem;
				}
			}
			a {
				width: 50%;
				img {
					width: 100%;
				}
			}
		}
	}
	@media all and (max-width: 768px) {
		section {
			border-bottom: 0.5rem solid #fff;
		}
		.flex {
			flex-wrap: wrap;
			.left {
				width: 100%;
				padding-right: 0;
			}
			.right {
				width: 60%;
				margin: 2rem auto 0;
				.bandcamp-container {
					width: 100%;
					max-width: none;
				}
			}
		}
	}
`;

export default ({ data }) => {
	const { top, title, copy, bottomText, bandcampLogo } = data;

	return (
		<StyledVideo>
			<Section>
				<Top color="green">{top}</Top>
				<h2>{title}</h2>
				<p>{copy}</p>
				<div className="flex">
					<div className="left">
						<div className="video-container">
							<iframe
								width="560"
								height="315"
								id="ytplayer"
								title="YouTube Player"
								src="https://www.youtube.com/embed/LDHO5Cfi-J0?controls=0"
								frameBorder="0"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
							/>
						</div>
					</div>
					<div className="right">
						<div className="bandcamp-container">
							<iframe
								src="https://bandcamp.com/EmbeddedPlayer/album=292363399/size=large/bgcol=333333/linkcol=9a64ff/tracklist=false/transparent=true/"
								seamless
								title="Bandcamp Widget"
							>
								<a href="https://arcadiaacademyofmusic.bandcamp.com/album/arcadia-newmarket">
									Arcadia Newmarket by Arcadia Academy of Music
								</a>
							</iframe>
						</div>
						<p className="bc-text">{bottomText}</p>
						<a
							target="_blank"
							rel="noopener noreferrer"
							href="https://arcadiaacademyofmusic.bandcamp.com/"
						>
							<img src={bandcampLogo.src} alt={bandcampLogo.alt} />
						</a>
					</div>
				</div>
			</Section>
		</StyledVideo>
	);
};
